import { SharedDocumentsRequest } from './sharedDocuments';

export interface WebCitation {
	url: string;
	domain?: string;
	title?: string;
}

export interface Conversation {
	id?: string;
	creationDateTime?: string | Date;
	lastMessageDateTime?: string | Date;
	text: string;
	sender: 'user' | 'assistant';
	type?: SharedDocumentsRequestType;
	data?: SharedDocumentsResponse | any;
	feedback?: 'positive' | 'negative';
	userId?: string;
	inferenceMetadata?: {
		promptTokens: number;
		completionTokens: number;
		totalTokens: number;
	};
	requestId?: string;
	isTyping?: boolean;
	functionCallResults?: string;
	isLoading?: boolean;
	webCitations?: WebCitation[];
}

export interface SendConversation {
	text: string;
	sender: 'user' | 'assistant';
	isTyping?: boolean;
}

export interface RecentConversation {
	id: string;
	creationDateTime: string | Date;
	lastMessageDateTime?: string | Date;
	archived?: boolean;
	title: string;
}

export interface Feedback {
	id?: string;
	message?: string;
	userQuery?: string;
	feedback?: 'positive' | 'negative';
	creationDateTime?: string | Date;
	dismissed?: boolean;
	conversationTitle?: string;
	messageId?: string;
	recentMessages?: any[]; // Array of recent messages including the AI message with feedback
	note?: string; // Admin notes about the feedback
	comment?: string; // User's comment on why the feedback was negative
}

export interface SharedDocumentsResponse {
	type: SharedDocumentsRequestType;
	sharedDocumentsRequestsList: SharedDocumentsRequest[];
}

export enum SharedDocumentsRequestType {
	TABLE_SHARED_DOCUMENTS_REQUEST = 'table',
	CARD_SHARED_DOCUMENTS_REQUEST = 'card'
}

export enum SharedDocumentsRequestFunctionNames {
	LIST_ALL_DOCUMENT_REQUESTS = 'list_all_document_requests',
	LIST_USER_SHARED_DOCUMENTS_REQUESTS = 'list_user_shared_documents_requests'
}

export enum AgentType {
	CHAT_AGENT = 'chatAgent',
	DOCUMENT_REQUEST_AGENT = 'documentRequestAgent'
}
